module.exports = __webpack_public_path__ + "img/saco-de-dinheiro.846bca91.svg";